import { Accordion, Link, Stack, Text } from "basis";
import { Question } from "./Question";

function LinkAccount({ initiallyOpen }) {
  return (
    <Accordion.Item initiallyOpen={initiallyOpen}>
      <Accordion.Item.Header>Link account</Accordion.Item.Header>
      <Accordion.Item.Content>
        <Stack gap="10">
          <Question title="How do I link my Latitude credit cards to my Latitude ID?">
            <Text>
              To link your Latitude credit card you will need to enter your card
              number and DOB. You will then be sent a SMS verification code to
              the mobile number we have on record. As an added security measure,
              we will check that the names on all accounts are identical (these
              may need to be updated otherwise). If there are any discrepancies
              in details between any accounts, you will need to get in touch to
              update your details.
            </Text>
          </Question>
          <Question title="How long is my email and SMS verification number valid for?">
            <Text>
              The registration verification code that has been sent to the email
              you provided is valid for 24 hours. The link account SMS
              verification code is valid for three minutes.
            </Text>
          </Question>
          <Question title="What should I do if I haven't received my SMS verification?">
            <Text>
              To ensure you receive your SMS verification during the account
              linking process you will need to make sure the mobile number
              associated with that particular card is up to date.
              <br />
              If you have updated the mobile number you will need to wait 24
              hours to re-attempt linking your account.
            </Text>
          </Question>
          <Question title="Can I link my personal loan and credit cards in the Latitude Service Centre?">
            <Text>
              You can link all of your Latitude Credit Cards and Personal Loans
              in the Latitude Service Centre.
            </Text>
          </Question>
          <Question
            title="Why can't I link another card?"
            productType="credit-card"
          >
            <Text>
              To ensure your account remains secure we perform background checks
              on stored details. If there are any discrepancies in details
              between any accounts, you won't be able to link another card and
              will need to get in touch with us to update your details. Once
              your details have been updated, you will be able to link your
              Latitude Credit Card or Personal Loan account.
            </Text>
          </Question>
          <Question
            title="Can I link my personal loan?"
            productType="personal-loan"
          >
            <Text>
              Yes, to link your Personal Loan account simply click the 'Link
              Account' button. You will need your account number, which can be
              found in your welcome email or on your loan statement.
            </Text>
          </Question>
          <Question
            title="Can I link my card using my account number?"
            productType="credit-card"
          >
            <Text>
              Yes. You can find your account number on your statement.
            </Text>
          </Question>
          <Question title="Why can’t I link another account in the Latitude Service Centre?">
            <Text>
              You can link multiple accounts to your Latitude ID. To do this,
              your personal details must be the same across your different
              accounts. We perform background checks on your stored details, so
              if there are any discrepancies in details between your accounts,
              you’ll need to update these by contacting us. For example, if you
              used an abbreviated name when applying for one account and not in
              the other, the details will need to align before linking with the
              Latitude Service Centre.
            </Text>
          </Question>
          <Question title="Still having trouble linking your account?">
            <Text>
              If you have any further questions, you can find our contact
              details on the{" "}
              <Link href="/contact" newTab={false}>
                Contact us
              </Link>{" "}
              page.
            </Text>
          </Question>
          <Question
            title="Having trouble linking an account using your card number?"
            productType="credit-card"
          >
            <Text>
              Try linking using your account number. You can find this on your
              statement.
            </Text>
          </Question>
          <Question
            title="Where can I find my loan account number?"
            productType="personal-loan"
          >
            <Text>
              Your account number can be found at the top of your statement or
              welcome pack that you would have received when you were approved.
            </Text>
          </Question>
          <Question
            title="I have a joint personal loan, can we all link our account to the Latitude Service Centre?"
            productType="personal-loan"
          >
            <Text>
              Yes, each person on the loan can link their account to their
              Latitude ID in the Latitude Service Centre. They can do this using
              their account number and date of birth. If you and your joint
              account holder have the same date of birth, you will be requested
              to provide more information to verify your identity.
            </Text>
          </Question>
          <Question
            title="What types of loans does the Latitude App support?"
            productType="personal-loan"
          >
            <Text>
              The Latitude App supports, Australian Latitude Personal Loan and
              New Zealand Gem Personal Loans.
              <br />
              At this stage, Kiwibank Personal Loans, Motor Loans and Mortgages
              are not supported.
            </Text>
          </Question>
          <Question title="Can I link my personal loan and credit cards in the Latitude Service Centre?">
            <Text>
              Yes. You can link your personal loan and Latitude credit cards by
              selecting Link Account on the home screen and providing your
              account number and date of birth.
            </Text>
          </Question>
          <Question
            title="Can I link my personal loan?"
            productType="personal-loan"
          >
            <Text>
              You can link your personal loan by selecting Link Account on the
              home screen and providing your account number and date of birth.
            </Text>
          </Question>
          <Question title="I have been locked out of SMS verification, what should I do?">
            <Text>
              If you enter the SMS code incorrectly more than five times, you
              will be locked out for five minutes. After five minutes you can
              try again.
            </Text>
          </Question>
        </Stack>
      </Accordion.Item.Content>
    </Accordion.Item>
  );
}

export { LinkAccount };
